import React from 'react';

const HowTo = () => {
  return (
    <>
      <div className="text-center mb-12">
        <h2 id="how-it-works-title" className="text-3xl md:text-4xl font-bold tracking-tight text-[var(--color-text-primary)] mb-4">How It Works</h2>
        <p id="how-it-works-description" className="text-lg text-[var(--color-text-secondary)] max-w-2xl mx-auto">A simple 4-step process to find the best time to post.</p>
      </div>
      <div id="how-to-steps-container" className="grid grid-cols-1 md:grid-cols-2 gap-8" data-testid="howTo-container">
        <div id="step-1" className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300" data-testid="howTo-step-1">
          <div className="flex items-center mb-4">
            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
              <span className="material-symbols-outlined text-3xl">public</span>
            </div>
            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">1. Provide Subreddit</h3>
          </div>
          <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">Enter the target subreddit to analyze its activity.</p>
        </div>
        <div id="step-2" className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300" data-testid="howTo-step-2">
          <div className="flex items-center mb-4">
            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
              <span className="material-symbols-outlined text-3xl">analytics</span>
            </div>
            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">2. Analyze</h3>
          </div>
          <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">Our AI will analyze the subreddit's activity to find the best posting times.</p>
        </div>
        <div id="step-3" className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300" data-testid="howTo-step-3">
          <div className="flex items-center mb-4">
            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
              <span className="material-symbols-outlined text-2xl">heatmap</span>
            </div>
            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">3. View Heatmap</h3>
          </div>
          <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">Explore the heatmap to visually identify peak activity hours.</p>
        </div>
        <div id="step-4" className="bg-container-light dark:bg-card-dark p-8 rounded-lg shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-300" data-testid="howTo-step-4">
          <div className="flex items-center mb-4">
            <div className="bg-[#1F7A8C]/10 dark:bg-[#1F7A8C]/20 text-[#1F7A8C] dark:text-[#BFDBF7] w-12 h-12 rounded-lg flex items-center justify-center mr-4 shrink-0">
              <span className="material-symbols-outlined text-3xl">recommend</span>
            </div>
            <h3 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">4. Get Recommendations</h3>
          </div>
          <p className="text-[#1F7A8C] dark:text-[#BFDBF7]">Receive specific recommendations for the best times to post.</p>
        </div>
      </div>
    </>
  );
};

export default HowTo;
